<template>
  <button
    class="round-button"
    :class="[color === 'red' ? 'red' : 'white']"
    @click="onClick"
  >
    {{ title }}
  </button>
</template>

<script>
export default {
  props: {
    color: String,
    title: String
  },

  methods: {
    onClick () {
      this.$emit('onClick')
    }
  }
}
</script>

<style lang="scss" scoped>
@use "@css/style.scss";
.round-button {
  font-size: 16px;
  border-radius: 22px;
  height: 44px;
  margin-top: 35px;
}

.red {
  color: white;
  background-color: #596afd;
  border: 1px solid #596afd;
}

.white {
  color: #323233;
  background-color: white;
  border: 1px solid #dcdee0;
}
</style>


#596afd